module.exports = __webpack_public_path__ + "img/insure.22f2ce2d.png";